export { default } from './StyledTab';
